<template>
  <div id="main-box">
    <toolbar
      id="btn-box"
      :buttonList="buttonList_toolBar"
      @callFunction="callFunction"
    ></toolbar>
    <div id="content-box">
      <el-card>
        <el-table
          :data="tableList"
          highlight-current-row
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @current-change="selectCurrentRow"
          style="width: 100%"
          border
        >
          <el-table-column
            prop="id"
            label="id"
            min-width="300"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="value"
            label="value"
            min-width="300"
            align="center"
          ></el-table-column>
        </el-table>
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          style="float: right"
          :total="total"
          :current-page="queryForm.pageIndex"
          :pageSize="queryForm.pageSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-card>
    </div>

    <el-dialog
      :title="isEdit ? '编辑' : '新增'"
      :visible.sync="propertyVisible"
      v-if="propertyVisible"
      v-model="propertyVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="propertyForm"
        label-width="120px"
        :rules="propertyFormRules"
        ref="propertyForm"
      >
        <el-form-item label="value" prop="value">
          <el-input v-model="propertyForm.value" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="propertyVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitProperty" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  PropertyValueCreate,
  PropertyValueDelete,
  PropertyValueUpdate,
  PropertyValueGetAll,
  PropertyValueGet
} from "../../../api/api";
import toolbar from "../../../components/Toolbar";
import {getButtonList} from "../../../promissionRouter";
export default {
  components: {toolbar},
  data() {
    return {
      buttonList_toolBar: [],
      buttonList_table: [],

      tableList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      queryForm: {
        pageIndex: 1,
        pageSize: 10
      },

      propertyVisible: false,
      isEdit: false,
      propertyForm: {
        value: null
      },
      propertyFormRules: {
        value: [
          { required: true, message: '请输入value', trigger: 'blur' },
          { message: '请输入value', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    };
  },
  mounted() {
    this.propertyId = parseInt(this.$route.query.id);
    this.getTableList();
    this.renderButton();
  },
  methods: {
    create() {
      this.propertyVisible = true;
      this.propertyForm = {
        value: null,
      };
      this.isEdit = false;
    },
    edit() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      PropertyValueGet(params).then((res) => {
        if (res.data.success) {
          that.propertyForm = res.data.result;
          that.isEdit = true;
          that.propertyVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    submitProperty() {
      let that = this;
      that.$refs.propertyForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            if (!that.isEdit) {
              that.propertyForm.propertyId = this.propertyId;
              PropertyValueCreate(that.propertyForm).then((res) => {
                that.submitLoading = false;
                that.propertyVisible = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.getTableList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              PropertyValueUpdate(that.propertyForm).then((res) => {
                that.submitLoading = false;
                that.propertyVisible = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.getTableList();
                } else {
                  that.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => {});
        }
      });
    },
    del() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        let that = this;
        PropertyValueDelete(params).then((res) => {
          that.tableLoading = false;
          if (res.data.success) {
            that.$message.success('删除成功');
            that.getTableList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => {});
    },
    detail(params) {
      let row = params.funcParams;
      this.$router.push(
        `/Product/ComManagement/PropertyDetail?id=${row.id}`
      );
    },
    renderButton() {
      let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
      this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
        return item.buttonShow == 20 && item.isVisible;
      }), 'order');
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getTableList() {
      this.tableLoading = true;
      let params = {
        PropertyId: this.propertyId,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      PropertyValueGetAll(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.tableList = res.data.result.items;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getTableList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    },
    empty() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
#main-box
{
  width: 100%;
  height:100%;
  padding-top: 40px;
}
#btn-box
{
  position: fixed;
  height: 60px;
  top: 94px;
  padding-left: 20px;
  padding-top: 16px;
}
#content-box
{
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
}
#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}
</style>
